module.exports = __webpack_public_path__ + "static/pop3-6c1521c8e555e346e4d6d8ef9f784fc2.jpg";